module.exports = __webpack_public_path__ + "static/media/STRAIGHT.83582e45.svg";